<div class="ms-3 mb-2" [ngClass]="inTable ? 'mt-1':'mt-3'">
  @if (!inTable) {
    <label>{{checkbox.title}}</label>
  }
  @for (chhBox of targets; track chhBox) {
    <div class="form-check form-switch">
      <input type="checkbox" class="form-check-input" name="{{chhBox.key}}" (change)="onChange($event, chhBox.key)"
        [checked]="isChecked(chhBox.key)" >
        <label class="form-check-label" for="{{chhBox.key}}">{{chhBox.name}}</label>
      </div>
    }
  </div>
